/**
 * Pasos del formulario de solicitud. Funciones puras, sin React: que pasos
 * existen, para quien, con que titulo y como se valida cada uno.
 *
 * El formulario los recorre como un stepper, igual que la Solicitud de grado
 * de Procesos Academicos: un paso a la vez, para que no se vea cargado.
 *
 * Quien no llena reserva (el estudiante en ARIA) no ve Clase ni Reserva; la
 * regla es la misma de siempre, puedeVerLogistica en model/permisos.js.
 */
import { TIPO_ARIA } from "../constants";
import { puedeVerLogistica } from "./permisos";
import {
  esValido,
  validarClase,
  validarEstudiantes,
  validarMaterial,
  validarReserva,
} from "./solicitud";

export const PASO_FECHA = "fecha";
export const PASO_CLASE = "clase";
export const PASO_RESERVA = "reserva";
export const PASO_ESTUDIANTES = "estudiantes";
export const PASO_MATERIAL = "material";

const conReserva = (perfil, tipo) => puedeVerLogistica(perfil, tipo);
const siempre = () => true;

// El docente empieza por la clase y la reserva, porque elegir la materia deja
// cargado el grupo para cuando llega a Estudiantes. El estudiante no reserva:
// dice quienes van, que niveles quiere y, de ultimo, que dia le sirve.
const PASOS = [
  {
    id: PASO_CLASE,
    etiqueta: () => "Clase",
    aplica: conReserva,
    validar: validarClase,
  },
  {
    id: PASO_RESERVA,
    etiqueta: () => "Reserva",
    aplica: conReserva,
    validar: validarReserva,
  },
  {
    id: PASO_ESTUDIANTES,
    etiqueta: () => "Estudiantes",
    aplica: siempre,
    validar: validarEstudiantes,
  },
  {
    id: PASO_MATERIAL,
    etiqueta: (tipo) => (tipo === TIPO_ARIA ? "Niveles" : "Libros"),
    aplica: siempre,
    validar: validarMaterial,
  },
  {
    // Quien no reserva puede proponer un dia; es opcional, asi que este
    // paso no valida nada.
    id: PASO_FECHA,
    etiqueta: () => "Fecha",
    aplica: (perfil, tipo) => !conReserva(perfil, tipo),
    validar: () => ({ errores: {}, mensaje: "" }),
  },
];

/** Los pasos que ve este perfil para este tipo de solicitud, en orden. */
export const pasosDe = (perfil, tipo) =>
  PASOS.filter(({ aplica }) => aplica(perfil, tipo));

/**
 * El primer paso que no esta completo, o -1 si todos lo estan. Al enviar se
 * revisan todos, porque se pudo haber llegado al ultimo sin pasar por alguno
 * (por ejemplo, al editar).
 *
 * @returns {{ indice: number, resultado: ?{ errores, mensaje } }}
 */
export const primerPasoConError = (pasos, partes) => {
  for (let indice = 0; indice < pasos.length; indice += 1) {
    const resultado = pasos[indice].validar(partes);
    if (!esValido(resultado)) return { indice, resultado };
  }
  return { indice: -1, resultado: null };
};
